const ProgramCalculateSelfPrice = (
  arrayData,
  selfPrice,
  master_id,
  size,
  water
) => {
  const selfItems = arrayData.filter(
    (item) => item.master_id === master_id && item?.isSelected
  );

  let waterprice = 0;

  const isSelectedWater = water?.filter((item) => item?.isSelected);

  if (isSelectedWater?.length > 0) {
    waterprice = isSelectedWater[0]?.price;
  }

  const selfPriceCalcurate = selfItems.reduce((acc, item) => {
    if (item?.price) {
      return acc + item?.price;
    } else {
      return acc + item[String(size).toLocaleLowerCase()];
    }
  }, 0);

  if (size && selfPrice) {
    return selfPriceCalcurate + selfPrice + waterprice;
  } else {
    return 0;
  }
};

export default ProgramCalculateSelfPrice;
